import { useTranslation } from "react-i18next";
import { useCallback } from "react";

export const TEMPLATE_CATEGORY_IDS = [
  "expedition",
  "transit",
  "delivery",
  "exception",
  "others",
] as const;

export type TemplateCategoryId = (typeof TEMPLATE_CATEGORY_IDS)[number];

// Default labels (used as fallback for translations)
const CATEGORY_DEFAULT_LABELS: Record<TemplateCategoryId, string> = {
  expedition: "Expedition",
  transit: "Transit",
  delivery: "Delivery",
  exception: "Exception",
  others: "Others",
};

// Legacy format for backwards compatibility
export const TEMPLATE_CATEGORIES = TEMPLATE_CATEGORY_IDS.map((id) => ({
  id,
  label: CATEGORY_DEFAULT_LABELS[id],
}));

export function getCategoryDefaultLabel(id: string): string {
  return CATEGORY_DEFAULT_LABELS[id as TemplateCategoryId] ?? id;
}

export function useCategoryLabel() {
  const { t } = useTranslation("trackoffice");

  return useCallback(
    (categoryId: string) =>
      t(
        `templatesEditor.categories.${categoryId}`,
        getCategoryDefaultLabel(categoryId),
      ),
    [t],
  );
}
